module.exports = __webpack_public_path__ + "img/proof-nyomtatas-mintakeszites-thumb.e59b92cb.jpg";